import type { SoftwareListSchema } from 'openapi'

import { SoftwareItem } from './SoftwareItem/SoftwareItem'

type Props = {
  software: SoftwareListSchema[]
}

export const SoftwareList = (props: Props) => {
  const { software } = props
  if (!software.length)
    return (
      <div className="flex justify-center items-center h-full text-2xl text-gray-400 py-40 font-extralight">
        Coming Soon
      </div>
    )

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-4 w-full items-stretch">
      {software.map((software) => (
        <SoftwareItem software={software} key={software.id} resizeWidth="300x" />
      ))}
    </div>
  )
}
